import React from 'react'
import TermsView from './TermsView'

export default () => <TermsView title="TERMS_CARD_TITLE" content="TERMS_CARD" />